import styled from "styled-components";
import { Drawer } from "antd";

export const WrapperCardProductGroups = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin: 16px;
  padding: 16px;
`;

export const WrapperModalProductGroups = styled(Drawer)``;
